export default __webpack_public_path__ + "static/media/shoe.c7c84109.jpeg";